import { createStore, createEvent, createEffect, combine } from 'effector';
import { createGate } from 'effector-react';
import { $data as $classTicket } from '@features/tickets-class-select';
import { $data as $invoiceStatuses } from '@features/tickets-invoices-status-select';
import { $data as $priority } from '@features/tickets-priority-select';
import { $data as $status } from '@features/tickets-status-select';
import {
  TicketsResponse,
  TicketsPayload,
  Users,
  UsersPayload,
  UsersResponse,
  GetDeviceNamePayload,
  GetDeviceNameResponse,
  Objects,
  ObjectsPayload,
  ObjectsResponse,
  GetInvoicesPayload,
  GetInvoicesResponse,
  InvoiceResponse,
  TypesResponse,
  TypesData,
  MarketOrder,
} from '../../interfaces';
import { Gate } from '../ticket/ticket.model';

export const path = '/tickets';

export const PageGate = createGate<Gate>();

export const pageUnmounted = PageGate.close;
export const pageMounted = PageGate.open;

export const changedErrorDialogVisibility = createEvent<boolean>();
export const open = createEvent<number>();
export const addClicked = createEvent<void>();
export const closeDetail = createEvent<void>();
export const getUsersData = createEvent<{ id: number }[]>();
export const getDeviceName = createEvent<GetDeviceNamePayload>();

/* События для обновления заявок по вебсокетам */
export const refreshTicketList = createEvent<void>();
export const updateTicketList = createEvent<void>();
export const changeTimeoutRefresh = createEvent<number>();
export const resetTimeoutRefresh = createEvent<number>();

export const getObjects = createEvent<Objects[]>();
export const changedEvent = createEvent<{ event: string }>();
export const getTicketInvoices = createEvent<number | null>();

export const fxGetTicketInvoices = createEffect<
  GetInvoicesPayload,
  GetInvoicesResponse,
  Error
>();
export const fxGetTicketList = createEffect<TicketsPayload, TicketsResponse, Error>();
export const fxGetUpdatedTicketList = createEffect<
  TicketsPayload,
  TicketsResponse,
  Error
>();
export const fxGetUsersData = createEffect<UsersPayload, UsersResponse, Error>();
export const fxGetDeviceName = createEffect<
  GetDeviceNamePayload,
  GetDeviceNameResponse,
  Error
>();

export const fxGetObjects = createEffect<ObjectsPayload, ObjectsResponse[], Error>();
export const fxGetTypes = createEffect<void, TypesResponse, Error>();

export const $timeoutTicketsRefresh = createStore<number>(0);
export const $isLoadingList = createStore<boolean>(true);
export const $types = createStore<TypesData[]>([]);
export const $invoices = createStore<{ [key: number]: InvoiceResponse[] }>({});
export const $marketOrders = createStore<{ [key: number]: MarketOrder[] }>({});
export const $objects = createStore<ObjectsResponse[]>([]);
export const $rawData = createStore<TicketsResponse>({
  tickets: [],
  total: 0,
});
export const $isLoading = createStore<boolean>(false);
export const $error = createStore<null | Error>(null);
export const $isErrorDialogOpen = createStore<boolean>(false);
export const $isDetailOpen = createStore<boolean>(false);
export const $usersData = createStore<string | Users[]>('');
export const $equipment = createStore<{ [key: number]: string }>({});
export const $rowCount = createStore<number>(0);
export const $tickets = combine(
  $rawData,
  $status,
  $priority,
  $classTicket,
  $types,
  $equipment,
  $usersData,
  $objects,
  $invoices,
  $invoiceStatuses,
  $marketOrders,
  (
    rawData,
    status,
    priority,
    classTicket,
    type,
    equipment,
    usersData,
    objects,
    invoices,
    invoiceStatuses,
    marketOrders
  ) => ({
    tickets: [...rawData.tickets],
    status,
    priority,
    classTicket,
    type,
    equipment,
    usersData,
    objects,
    invoices,
    invoiceStatuses,
    marketOrders,
  })
);
